import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { RecompCycleProductSummary } from './RecompCycleProductSummary';
import { RecompCycleProductAccountSummary } from './RecompCycleProductAccountSummary';
import { RecompSummaryReportExists } from './RecompSummaryReportExists';

export class RecompResource extends FBaseService {
  public async getRecompCycleProductSummaries(fiId: number, reloadId: string): Promise<RecompCycleProductSummary[]> {
    const url: string = `/api/rcx/reporting/${fiId}/recomp/cycle-product-summary/${reloadId}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    const result: RecompCycleProductSummary[] = response.data.data;
    return result;
  }

  public async getRecompCycleProductAccountSummaries(fiId: number, reloadId: string): Promise<RecompCycleProductAccountSummary[]> {
    const url: string = `/api/rcx/reporting/${fiId}/recomp/cycle-product-account-summary/${reloadId}`;

    const response: AxiosResponse = await this.apiClient.get(url);

    const result: RecompCycleProductAccountSummary[] = response.data.data;
    return result;
  }

  public async doesRecompSummaryReportExists(fiId: number, reloadId: string): Promise<RecompSummaryReportExists> {
    const s3keyPrefix = encodeURIComponent(`krp-reporting/${fiId}/Cycle_ReCalc/`);
    const correlationId = encodeURIComponent(reloadId);
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/reporting/${fiId}/report-exists?s3key=${s3keyPrefix}&correlationId=${correlationId}`);
    const result: RecompSummaryReportExists = response.data.data;
    return result;
  }

  public async downloadReportAsBlob(fiId: number, reloadId: string, s3Key: string): Promise<Blob> {
    const s3FileKey = encodeURIComponent(s3Key);
    const correlationId = encodeURIComponent(reloadId);
    const urlDownload = `/api/rcx/reporting/${fiId}/s3key-download?s3key=${s3FileKey}&correlationId=${correlationId}`;
    const response: AxiosResponse = await this.apiClient.get(urlDownload, { responseType: 'blob' });
    return response.data;
  }
}

export default RecompResource;
